import { FC, ReactNode, memo, useMemo } from 'react'
import theme from '@utils/theme'
import { StyledTypography } from './style'
interface TypographyProps {
  variant?: keyof JSX.IntrinsicElements
  children?: ReactNode
  content?: string
  tc?: keyof typeof theme.colors
  size?: number
  styleText?: any
  lineHeight?: number
  weigth?: number
  onClick?: () => void
}
const Typography: FC<TypographyProps> = memo(
  ({ children, content, variant = 'p', ...restProps }) => {
    const Component = useMemo(
      () => StyledTypography.withComponent(variant),
      [variant],
    )
    return <Component {...restProps}>{children || content}</Component>
  },
)

Typography.displayName = 'Typography'

export default Typography
